import React, { useState } from 'react'
import Flex, { IFlexProps } from 'typescript-styled-flex'
import { FiEdit2, FiPlus } from 'react-icons/fi'
import AddButton from '../../AddButton'
import { theme } from '../../../theme'
import SpinningIcon from '../../Template/SpinningIcon'
import FlexGroup from './FlexGroup'
import Title from './Title'
import { PopoveredIcon2 } from '../../PopoveredIcon/PopoveredIcon'
import { useMediaQuery, useTheme } from '@material-ui/core'
import UpgradePremiumBlockScreenModal
  from '../../../containers/UpgradePremiumBlockScreenModal/UpgradePremiumBlockScreenModal'

function FormGroup({
  children,
  title,
  style,
  styleGroup,
  withButton,
  toggle,
  size = 1,
  withEdit = false,
  loading = false,
  toggleClassName = undefined,
  withoutBtnPadding,
  className = undefined,
  withoutTitle = false,
  flexStyle = {},
  isDisabled,
  withPopoverIcon,
  addBtnActive=true,
  ...rest
}: IFormGroupProps & IFlexProps) {
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  const theme2 = useTheme()
  const isMobile = useMediaQuery(theme2.breakpoints.down('sm'))
  const [isModalOpened, setIsModalOpened] = useState(false)

  const handlePopoverOpen = event => {
    event.preventDefault()
    event.stopPropagation()
    setPopoverAnchor(event.currentTarget)
  }

  const handlePopoverClose = event => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setPopoverAnchor(null)
  }
  return (
    <Flex
      column={true}
      style={{
        marginTop: withoutBtnPadding ? `${7 * size}px` : `${5 * size}px`,
        width: '100%',
        ...flexStyle,
      }}
    >
      {!withoutTitle && (
        <Title
          style={{
            ...style,
            fontSize:
              style && style.fontSize ? style.fontSize : `${16 * size}px`,
          }}
          withButton={withButton}
          size={size}
        >
          {withButton ? (
            <Flex row={true} full={true} justifyBetween={true}>
              <Flex full={true} style={{ alignItems: 'center', gap: '8px' }}>
                {typeof title === 'string' ? title : title()}
                {withPopoverIcon && (
                  <PopoveredIcon2
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    anchorEl={popoverAnchor}
                    onClose={handlePopoverClose}
                  />
                )}
              </Flex>
              {loading ? (
                <SpinningIcon
                  style={{
                    height: `${24 * size}px`,
                    marginRight: `${-10 * size}px`,
                    width: `${24 * size}px`,
                  }}
                />
              ) : withEdit ? (
                <FiEdit2
                  data-cy={className + '-edit-button'}
                  onClick={isDisabled ? isMobile ? () => setIsModalOpened(true) : handlePopoverOpen : toggle}
                  size={`${24 * size}px`}
                  style={{
                    color: isDisabled ? theme.colors.palette.warmGreytThree : theme.colors.palette.emerald,
                    cursor: 'pointer',
                    marginRight: `${-10 * size}px`,
                  }}
                />
              ) : (
                <AddButton
                  data-cy={className + '-add-button'}
                  className={toggleClassName}
                  size={size}
                  style={{ marginRight: `${-10 * size}px` }}
                  onClick={isDisabled ? isMobile  ? !addBtnActive ? undefined :  () => setIsModalOpened(true) : handlePopoverOpen : toggle}
                  isDisabled={isDisabled}
                >
                  <FiPlus />
                </AddButton>
              )}
            </Flex>
          ) : typeof title === 'string' ? (
            <Flex style={{ alignItems: 'center', gap: '8px' }}>
              {title}
              {withPopoverIcon && (
                <PopoveredIcon2
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  anchorEl={popoverAnchor}
                  onClose={handlePopoverClose}
                />
              )}
            </Flex>
          ) : (
            <Flex style={{ alignItems: 'center', gap: '8px' }}>
              {title()}
              {withPopoverIcon && (
                <PopoveredIcon2
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  anchorEl={popoverAnchor}
                  onClose={handlePopoverClose}
                />
              )}
            </Flex>
          )}
        </Title>
      )}

      <FlexGroup
        // onClick={e => isMobile ? setIsModalOpened(true) : handlePopoverOpen(e)}
        size={size}
        style={{ position: 'relative', ...styleGroup }}
        column={rest.row ? rest.row : rest.column}
        {...rest}
      >
        {/*{withPopoverIcon && (*/}
        {/*  <Flex*/}
        {/*    onClick={e => isMobile ? setIsModalOpened(true) :  handlePopoverOpen(e) }*/}
        {/*    style={{*/}
        {/*      position: 'absolute',*/}
        {/*      bottom: 0,*/}
        {/*      top: 0,*/}
        {/*      left: 0,*/}
        {/*      right: 0,*/}
        {/*      backgroundColor: 'transparent',*/}
        {/*      zIndex: 100,*/}
        {/*    }}*/}
        {/*  ></Flex>*/}
        {/*)}*/}
        {children}
      </FlexGroup>
      {isMobile && <UpgradePremiumBlockScreenModal
        open={isModalOpened}
        close={() => setIsModalOpened(false)}
      />}
    </Flex>
  )
}

export default FormGroup
export { FlexGroup }

type ReactTitle = () => JSX.Element

export interface IFormGroupProps {
  children: React.ReactNode
  title: string | ReactTitle | any
  style?: React.CSSProperties
  withEdit?: boolean
  loading?: boolean
  styleGroup?: object
  withButton?: boolean
  className?: any
  size?: number
  withoutBtnPadding?: boolean
  onClick?: () => void
  toggleClassName?: any
  isDisabled?: boolean
  toggle?: () => void
  flexStyle?: React.CSSProperties
  withoutTitle?: boolean
  witPopoverIcon?: boolean
  addBtnActive?: boolean
}
